var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.923 2.385H3.077C1.93 2.385 1 3.315 1 4.462v12.461C1 18.07 1.93 19 3.077 19h13.846C18.07 19 19 18.07 19 16.923V4.462c0-1.148-.93-2.077-2.077-2.077z",
    stroke: "#ED1B2E",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5.846H1M4.462 1v1.385V1zm11.076 0v1.385V1z",
    stroke: "#ED1B2E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgCalendarRed;